/*
 * O bloco de carregamento, com a ALTURA FINAL de quem ele substitui (doc 06a §7).
 *
 * A altura vem de quem usa, em `className`: sem ela o conteúdo salta quando chega,
 * e o operador perde o lugar. `aria-hidden` porque o carregamento é dito pela
 * superfície (`aria-busy`), e não por uma caixa vazia.
 */
export function Esqueleto({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`rounded-controle bg-superficie-2 motion-safe:animate-pulse ${className}`}
    />
  );
}
